import { Radar, Warehouse } from 'lucide-react';
import { cn } from '@eombor/ui';
import { t } from '../../../shared/i18n/index.js';

/**
 * OMBORLAR BO'YLAB QIDIRUV — kutish holati.
 *
 * Bu oddiy spinner emas va ataylab. Buyurtmachi shu tugmani bosganda
 * ekranning qamrovi kengayadi: bitta ombor o'rniga hammasi qidiriladi.
 * Aylanayotgan doira bu o'zgarishni AYTMAYDI — u faqat "kutinг" deydi.
 *
 * Shuning uchun kutish o'zi javobning bir qismi bo'ladi: qaysi omborlar
 * qaralayotgani ro'yxat bo'lib chiqadi va natija kelganda odam uni "shu
 * omborlardan biridan" deb o'qiydi.
 */

/** Ekranga sig'adigan ombor nomi — qolgani sanoq bo'lib qisqaradi. */
const SHOWN = 6;

export interface WarehouseSweepProps {
  /** Qidirilayotgan matn — bo'sh bo'lsa yozilmaydi. */
  query: string;
  warehouseNames: readonly string[];
}

export const WarehouseSweep = ({ query, warehouseNames }: WarehouseSweepProps) => (
  <div
    role="status"
    aria-live="polite"
    className={cn(
      'motion-fade-in flex flex-col items-center gap-4 rounded-[var(--radius-lg)]',
      'border border-border bg-surface px-5 py-8 shadow-[var(--shadow-1)]',
    )}
  >
    <span
      aria-hidden
      className={cn(
        'motion-pulse-soft flex size-14 items-center justify-center rounded-full',
        'bg-accent-soft text-accent [--pulse-color:var(--color-accent)]',
      )}
    >
      <Radar size={26} />
    </span>

    <p className="text-center text-sm font-medium text-balance text-text">
      {query === ''
        ? t('requisition.sweepAll', { count: warehouseNames.length })
        : t('requisition.sweepQuery', { q: query, count: warehouseNames.length })}
    </p>

    {/* Supurgi — qidiruv omborlar bo'ylab yurib chiqmoqda. */}
    <span
      aria-hidden
      className="relative h-1 w-full max-w-sm overflow-hidden rounded-full bg-surface-2"
    >
      <span
        className={cn(
          'motion-sweep absolute inset-y-0 left-0 w-1/3 rounded-full',
          'bg-gradient-to-r from-transparent via-[var(--color-accent)] to-transparent',
        )}
      />
    </span>

    {warehouseNames.length === 0 ? null : (
      <ul className="flex flex-wrap justify-center gap-1.5">
        {warehouseNames.slice(0, SHOWN).map((name, index) => (
          <li
            key={name}
            className={cn(
              'motion-slide-in flex items-center gap-1.5 rounded-[var(--radius-pill)]',
              'border border-border bg-surface-2 px-2.5 py-1 text-xs text-text-muted',
            )}
            style={{ animationDelay: `${index * 90}ms` }}
          >
            <Warehouse size={11} aria-hidden className="shrink-0 text-text-faint" />
            {name}
          </li>
        ))}
        {warehouseNames.length > SHOWN ? (
          <li className="px-1 py-1 text-xs text-text-faint">
            {t('stock.moreWarehouses', { count: warehouseNames.length - SHOWN })}
          </li>
        ) : null}
      </ul>
    )}
  </div>
);
